const calculatorConfigObject = {
    resultsPagePath: "/prijsindicatie",
    hourlyRate: 90,
    questions: [{
        questionText: "Voor welke platformen moet jouw app geschikt zijn?",
        stepName: "Platformen",
        answerType: "radio",
        answers: [{
            answerText: "Apple iOS",
            icon: "/build/images/calculator/platform/ios.svg",
            multiplier: 1
        }, {
            answerText: "Android",
            icon: "/build/images/calculator/platform/android.svg",
            multiplier: 1.1
        }, {
            answerText: "Apple iOS en Android",
            icon: "/build/images/calculator/platform/hybrid.svg",
            multiplier: 1.25
        }]
    }, {
        questionText: "Op welke devices moet de app kunnen draaien?",
        stepName: "Devices",
        answerType: "radio",
        answers: [{
            answerText: "Smartphones",
            icon: "/build/images/calculator/devices/icon-phone.svg",
            multiplier: 1
        }, {
            answerText: "Tablets",
            icon: "/build/images/calculator/devices/icon-tablet.svg",
            multiplier: 1.1
        }, {
            answerText: "Smartphones en tablets",
            icon: "/build/images/calculator/devices/icon-smartwatch.svg",
            multiplier: 1.25
        }]
    }, {
        questionText: "Hoeveel verschillende soorten schermen zijn er?",
        stepName: "Aantal schermen",
        answerType: "radio",
        answers: [{
            answerText: "1-7 schermen",
            icon: "/build/images/calculator/number-of-screens/icon-screens_1-7.svg",
            minHours: 40,
            maxHours: 60
        }, {
            answerText: "8-15 schermen",
            icon: "/build/images/calculator/number-of-screens/icon-screens_8-15.svg",
            minHours: 60,
            maxHours: 120
        }, {
            answerText: "16-25 schermen",
            icon: "/build/images/calculator/number-of-screens/icon-screens_16-25.svg",
            minHours: 120,
            maxHours: 160
        }, {
            answerText: "25+ schermen",
            icon: "/build/images/calculator/number-of-screens/icon-screens_25+.svg",
            minHours: 160,
            maxHours: 280
        }]
    }, {
        questionText: "Hoeveel aandacht mogen wij aan het design besteden?",
        stepName: "Design",
        answerType: "radio",
        answers: [{
            answerText: "Geen design, ik lever dit zelf aan",
            icon: "/build/images/calculator/design/icon-existing-design.svg",
            minHours: 0,
            maxHours: 0
        }, {
            answerText: "Stock design",
            icon: "/build/images/calculator/design/icon-template.svg",
            minHours: 8,
            maxHours: 16
        }, {
            answerText: "Uniek maatwerk design",
            icon: "/build/images/calculator/design/icon-custom.svg",
            minHours: 40,
            maxHours: 60
        }]
    }, {
        questionText: "Welke log-in mogelijkheden wil je je klanten bieden?",
        stepName: "Authenticatie",
        answerType: "checkbox",
        answers: [{
            answerText: "E-mail",
            icon: "/build/images/calculator/authentication/icon-email.svg",
            minHours: 12,
            maxHours: 16
        }, {
            answerText: "Facebook",
            icon: "/build/images/calculator/authentication/icon-facebook.svg",
            minHours: 6,
            maxHours: 8
        }, {
            answerText: "Google",
            icon: "/build/images/calculator/authentication/icon-google.svg",
            minHours: 6,
            maxHours: 8
        }, {
            answerText: "Apple",
            icon: "/build/images/calculator/authentication/icon-apple.svg",
            minHours: 4,
            maxHours: 6
        }, {
            answerText: "Two-Factor Authenticatie",
            icon: "/build/images/calculator/authentication/icon-2factor-authentication.svg",
            minHours: 8,
            maxHours: 12
        }]
    }, {
        questionText: "Welke soort content wil je je klanten laten zien?",
        stepName: "Content",
        answerType: "checkbox",
        answers: [{
            answerText: "Statische content",
            icon: "/build/images/calculator/content/icon-static.svg",
            minHours: 4,
            maxHours: 8
        }, {
            answerText: "Nieuws/blog",
            icon: "/build/images/calculator/content/icon-news.svg",
            minHours: 6,
            maxHours: 8
        }, {
            answerText: "Dashboard",
            icon: "/build/images/calculator/content/icon-dashboard.svg",
            minHours: 8,
            maxHours: 12
        }, {
            answerText: "Gebeurtenissen",
            icon: "/build/images/calculator/content/icon-activity-timeline.svg",
            minHours: 6,
            maxHours: 8
        }, {
            answerText: "Agenda",
            icon: "/build/images/calculator/content/icon-events.svg",
            minHours: 6,
            maxHours: 8
        }, {
            answerText: "Producten catalogus",
            icon: "/build/images/calculator/content/icon-catalog.svg",
            minHours: 8,
            maxHours: 16
        }]
    }, {
        questionText: "Wat wil je dat de gebruiker kan doen?",
        stepName: "Gebruikerfuncties",
        answerType: "checkbox",
        answers: [{
            answerText: "Persoonlijk profiel",
            icon: "/build/images/calculator/engagement/icon-profile.svg",
            minHours: 8,
            maxHours: 12
        }, {
            answerText: "Reacties plaatsen",
            icon: "/build/images/calculator/engagement/icon-comments.svg",
            minHours: 12,
            maxHours: 16
        }, {
            answerText: "Reviews achterlaten",
            icon: "/build/images/calculator/engagement/icon-rating.svg",
            minHours: 16,
            maxHours: 24
        }, {
            answerText: "Berichten sturen",
            icon: "/build/images/calculator/engagement/icon-messages.svg",
            minHours: 8,
            maxHours: 16
        }, {
            answerText: "Formulieren invullen",
            icon: "/build/images/calculator/engagement/icon-forms.svg",
            minHours: 12,
            maxHours: 40
        }, {
            answerText: "Reserveringen plaatsen",
            icon: "/build/images/calculator/engagement/icon-booking.svg",
            minHours: 16,
            maxHours: 24
        }, {
            answerText: "Media (foto, video) plaatsen",
            icon: "/build/images/calculator/engagement/icon-share.svg",
            minHours: 12,
            maxHours: 20
        }, {
            answerText: "Documenten uploaden",
            icon: "/build/images/calculator/engagement/icon-upload file.svg",
            minHours: 10,
            maxHours: 16
        }]
    }, {
        questionText: "Welke soorten media gebruikt de app?",
        stepName: "Media",
        answerType: "checkbox",
        answers: [{
            answerText: "Audio afspelen",
            icon: "/build/images/calculator/media/audio_playback_icon.svg",
            minHours: 12,
            maxHours: 20
        }, {
            answerText: "Audio opnemen",
            icon: "/build/images/calculator/media/audio_recording_icon.svg",
            minHours: 10,
            maxHours: 16
        }, {
            answerText: "Video bekijken",
            icon: "/build/images/calculator/media/video_playback_icon.svg",
            minHours: 10,
            maxHours: 16
        }, {
            answerText: "Video opnemen",
            icon: "/build/images/calculator/media/video_recording_icon.svg",
            minHours: 12,
            maxHours: 20
        }, {
            answerText: "Toegang tot foto/video bibliotheek",
            icon: "/build/images/calculator/media/photo_video_acces_icon.svg",
            minHours: 10,
            maxHours: 16
        }]
    }, {
        questionText: "Welke andere mogelijkheden wil je inbouwen?",
        stepName: "Aanvullende opties",
        answerType: "checkbox",
        answers: [{
            answerText: "Tutorial van de app",
            icon: "/build/images/calculator/features/app_walkthrough_icon.svg",
            minHours: 8,
            maxHours: 16
        }, {
            answerText: "Kaarten en routes laten zien",
            icon: "/build/images/calculator/features/display_map_data_icon.svg",
            minHours: 8,
            maxHours: 12
        }, {
            answerText: "QR codes",
            icon: "/build/images/calculator/features/qr_code_icon.svg",
            minHours: 6,
            maxHours: 10
        }, {
            answerText: "Meertalig",
            icon: "/build/images/calculator/features/multilingual_icon.svg",
            minHours: 8,
            maxHours: 24
        }, {
            answerText: "Offline modus",
            icon: "/build/images/calculator/features/offline_icon.svg",
            minHours: 8,
            maxHours: 20
        }, {
            answerText: "Deep linking",
            icon: "/build/images/calculator/features/deep_linking_icon.svg",
            minHours: 6,
            maxHours: 10
        }]
    }, {
        questionText: "Welke sensoren gebruikt de app?",
        stepName: "Sensoren",
        answerType: "checkbox",
        answers: [{
            answerText: "Camera",
            icon: "/build/images/calculator/sensors/camera_icon.svg",
            minHours: 12,
            maxHours: 20
        }, {
            answerText: "GEO-locatie (GPS)",
            icon: "/build/images/calculator/sensors/geolocation_icon.svg",
            minHours: 10,
            maxHours: 16
        }, {
            answerText: "Gyroscoop",
            icon: "/build/images/calculator/sensors/gyroscope_icon.svg",
            minHours: 10,
            maxHours: 16
        }, {
            answerText: "Versnellingsmeter",
            icon: "/build/images/calculator/sensors/accelerometer_icon.svg",
            minHours: 12,
            maxHours: 20
        }, {
            answerText: "Barometer",
            icon: "/build/images/calculator/sensors/barometer_icon.svg",
            minHours: 10,
            maxHours: 16
        }, {
            answerText: "Pedometer",
            icon: "/build/images/calculator/sensors/pedometer_icon.svg",
            minHours: 8,
            maxHours: 12
        }, {
            answerText: "Haptisch",
            icon: "/build/images/calculator/sensors/haptics_icon.svg",
            minHours: 10,
            maxHours: 16
        }]
    }, {
        questionText: "Welke functionaliteiten heeft de administrator van de app nodig?",
        stepName: "Beheer",
        answerType: "checkbox",
        answers: [{
            answerText: "Content management",
            icon: "/build/images/calculator/admin/content_management_icon.svg",
            minHours: 6,
            maxHours: 16
        }, {
            answerText: "Moderatie en goedkeuren content",
            icon: "/build/images/calculator/admin/moderation_approval.svg",
            minHours: 4,
            maxHours: 8
        }, {
            answerText: "Gebruikersmanagement",
            icon: "/build/images/calculator/admin/user_management_icon.svg",
            minHours: 8,
            maxHours: 12
        }, {
            answerText: "Datamanagement",
            icon: "/build/images/calculator/admin/data_management_icon.svg",
            minHours: 16,
            maxHours: 40
        }, {
            answerText: "Notificaties versturen",
            icon: "/build/images/calculator/admin/notifications_icon.svg",
            minHours: 6,
            maxHours: 10
        }]
    }, {
        questionText: "Hoe ga je communiceren met de gebruikers?",
        stepName: "Communicatie",
        answerType: "checkbox",
        answers: [{
            answerText: "E-mail",
            icon: "/build/images/calculator/communication/emails_icon.svg",
            minHours: 8,
            maxHours: 16
        }, {
            answerText: "Push notificaties",
            icon: "/build/images/calculator/communication/push_notifications_icon.svg",
            minHours: 6,
            maxHours: 10
        }, {
            answerText: "SMS berichten",
            icon: "/build/images/calculator/communication/sms_integration_icon.svg",
            minHours: 12,
            maxHours: 20
        }]
    }, {
        questionText: "Wil je een API kunnen koppelen?",
        stepName: "Integraties",
        answerType: "checkbox",
        answers: [{
            answerText: "Verbinden met website",
            icon: "/build/images/calculator/integrations/connect_website_icon.svg",
            minHours: 8,
            maxHours: 16
        }, {
            answerText: "Verbinden met een bedrijfsserver",
            icon: "/build/images/calculator/integrations/business_server_icon.svg",
            minHours: 12,
            maxHours: 24
        }, {
            answerText: "Verbinden met open API",
            icon: "/build/images/calculator/integrations/public_api.svg",
            minHours: 10,
            maxHours: 14
        }]
    }, {
        questionText: "Welk verdienmodel heeft de app?",
        stepName: "Verdienmodel",
        answerType: "checkbox",
        answers: [{
            answerText: "Gratis gebruik",
            icon: "/build/images/calculator/monetization/free_use_icon.svg",
            minHours: 0,
            maxHours: 0
        }, {
            answerText: "Advertenties in de app",
            icon: "/build/images/calculator/monetization/in-app_advertisements_icon.svg",
            minHours: 12,
            maxHours: 16
        }, {
            answerText: "Aankopen in de app",
            icon: "/build/images/calculator/monetization/in-app_purchases_icon.svg",
            minHours: 8,
            maxHours: 12
        }, {
            answerText: "Abonnementen",
            icon: "/build/images/calculator/monetization/subscription_plans_icon.svg",
            minHours: 8,
            maxHours: 12
        }]
    }]
}

const stateMachine = {
    currentStep: -1,
    stepContainerDOMObject: null,
    estimation: [],
    currentQuestion: null,
    currentSelection: [],
    possibleAnswers: [],
    disableNextButton: function () {
        $("#stepForward").addClass('disabled');
    },
    enableNextButton: function () {
        $("#stepForward").removeClass('disabled');
    },
    minValue: 0,
    maxValue: 0,
    changeEstimationValue: function (value) {
        $("#estimationValue").html(value);
    },
    updateStepper: function () {
        $(".calculator-steps__progression .wrapper").html("");
        for (const i in this.estimation) {
            const estimationPart = this.estimation[i];
            $(".calculator-steps__progression .wrapper").append(`<div data-step-number="${i}" class="calculator-steps__answered">
                <i class="icon icon-check"></i>
                <p>${estimationPart.stepName}</p>
            </div>`);
        }

        $(".calculator-steps__progression .wrapper").append(`<div class="calculator-step active">
            <i class="icon icon-dot"></i>
            <p>${this.currentQuestion.stepName}</p>
        </div>`);
    },
    scrollToTopOfEstimator: function () {
        document.getElementById("calculator-description").scrollIntoView();
    },
    currencyFormatter: function (number) {
        return (number).toLocaleString('nl-NL', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        });
    },
    getEstimateEvaluation: function(extraData = []) {
        let minHours = 0, maxHours = 0;
        const multipliers = [];
        const estimation = this.estimation.concat(extraData);
        for (const i in estimation) {
            const estimationPart = estimation[i];
            for (const j in estimationPart.answers) {
                const answer = estimationPart.answers[j];
                if (answer.multiplier) {
                    multipliers.push(answer.multiplier);
                } else {
                    minHours += answer.minHours;
                    maxHours += answer.maxHours;
                }
            }
        }

        for (const i in multipliers) {
            const multiplier = multipliers[i];
            minHours *= multiplier;
            maxHours *= multiplier;
        }

        return {
            minHours: minHours,
            maxHours: maxHours,
            minPrice: minHours * calculatorConfigObject.hourlyRate,
            maxPrice: maxHours * calculatorConfigObject.hourlyRate,
        };
    },
    evaluateEstimationValue: function () {
        const evaluation = this.getEstimateEvaluation();

        this.minValue = evaluation.minHours;
        this.maxValue = evaluation.maxHours;

        if (evaluation.maxPrice) {
            this.changeEstimationValue(`${this.currencyFormatter(evaluation.minPrice)} - ${this.currencyFormatter(evaluation.maxPrice)}`);
        } else {
            this.changeEstimationValue("€ 0");
        }
    },
    loadQuestionText: function () {
        this.currentQuestion = calculatorConfigObject.questions[this.currentStep];
        $("#questionText").html(this.currentQuestion.questionText);
    },
    loadAnswers: function () {
        this.possibleAnswers = this.currentQuestion.answers;
        $(".calculator-steps__option").remove();
        for (const i in this.possibleAnswers) {
            const possibleAnswer = this.possibleAnswers[i];
            this.stepContainerDOMObject.append(`<div class="calculator-steps__option" data-answername="${possibleAnswer.answerText}">
            <img src="${possibleAnswer.icon}" alt="${possibleAnswer.answerText}">
            <p>${possibleAnswer.answerText}</p>
        </div>`);
        }
    },
    stepToSection: function (numberOfStep) {
        this.currentStep = numberOfStep;
        this.loadQuestionText();
        this.loadAnswers();

        this.estimation = this.estimation.slice(0, numberOfStep);

        this.currentSelection = [];
        this.currentSelection.length = 0;

        this.evaluateEstimationValue();

        this.disableNextButton();
        this.updateStepper();
    },
    stepBackwards: function () {
        if(this.currentStep !== 0) {
            this.stepToSection(this.currentStep - 1);
        }
    },
    stepForward: function (skipStep) {
        if (this.currentStep < calculatorConfigObject.questions.length - 1) {
            this.currentStep++;
            this.loadQuestionText();
            this.loadAnswers();

            if (skipStep) {
                this.currentSelection = [];
                this.currentSelection.length = 0;
            } else {
                this.estimation.push({
                    stepName: calculatorConfigObject.questions[this.currentStep - 1].stepName,
                    answers: this.currentSelection
                });

                this.evaluateEstimationValue();
                this.currentSelection = [];
                this.currentSelection.length = 0;
            }

            this.disableNextButton();
            this.updateStepper();

        } else {
            const jsonEstimation = JSON.stringify(this.estimation);

            localStorage.estimation = jsonEstimation;
            localStorage.hourlyRate = calculatorConfigObject.hourlyRate;
            localStorage.minHours = this.minValue;
            localStorage.maxHours = this.maxValue;

            axios.post('/ajax/estimation/store', {
                estimation: jsonEstimation,
                hourly_rate: calculatorConfigObject.hourlyRate,
                min_hours: this.minValue,
                max_hours: this.maxValue
            })
            .then((response) => {
                localStorage.estimationId = response.data.id;
            })
            .catch(() => {
                localStorage.estimationId = null;
            })
            .finally(() => {
                window.location = calculatorConfigObject.resultsPagePath;
            });
        }
    },
    selectAnswer: function (answerName) {
        $(".calculator-steps__option").removeClass('active');

        const selectedAnswer = this.possibleAnswers.find(function (value) {
            return value.answerText === answerName;
        });

        if (this.currentQuestion.answerType === "radio") {
            this.currentSelection = [selectedAnswer];
        } else {

            answerExists = this.currentSelection.find(function (value) {
                return value.answerText === answerName;
            });

            if (!answerExists) {
                this.currentSelection.push(selectedAnswer);
            } else {
                this.currentSelection = this.currentSelection.filter(function (value) {
                    return value.answerText !== answerExists.answerText;
                });
            }
        }

        for (const i in this.currentSelection) {
            $(`[data-answername="${this.currentSelection[i].answerText}"].calculator-steps__option`).addClass('active');
        }

        const estimation = this.getEstimateEvaluation({answers: this.currentSelection});
        if (estimation.maxPrice) {
            this.changeEstimationValue(`${this.currencyFormatter(estimation.minPrice)} - ${this.currencyFormatter(estimation.maxPrice)}`);
        } else {
            this.changeEstimationValue("€ 0");
        }

        this.enableNextButton();
    },
    init: function () {
        delete localStorage.estimation;
        delete localStorage.hourlyRate;
        delete localStorage.minHours;
        delete localStorage.maxHours;

        const _this = this;
        this.stepContainerDOMObject = $(".calculator-steps__all-options");
        $("#stepForward").click(function () {
            _this.stepForward();
            _this.scrollToTopOfEstimator();
        });
        $("#back").click(function () {
            _this.stepBackwards();
            _this.scrollToTopOfEstimator();
        });
        $("#skip").click(function () {
            _this.stepForward(true);
            _this.scrollToTopOfEstimator();
        });
        $(".calculator-steps__all-options").on("click", ".calculator-steps__option", function () {
            _this.selectAnswer($(this).data('answername'));
        });
        $('.calculator-steps').on("click", ".calculator-steps__answered", function(){
            _this.stepToSection($(this).data('step-number'));
        });
        _this.stepForward(true);
        this.changeEstimationValue("€ 0");
    }
};

$(document).ready(function () {
    stateMachine.init();
});
